export const VALIDATION_TYPE = {
    REQUIRED: 'required',
    MIN_LENGTH: 'minLength',
    ALLOW_CHAR_AND_NUMBER: 'allowCharAndNumber',
    DUPLICATE_WORKGROUP_NAME: 'duplicateWorkgroupName',
};

export const DEFAULT_WORKGROUP = {
    id: -1,
    defaultWorkGroup: '',
    workGroupName: '',
    tags: [],
};
